import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb, Table, Alert } from "@themesberg/react-bootstrap";
import { useParams } from "react-router-dom";
import moment from "moment";
import { BaseUrl } from "../Routes/BaseUrl";
import { fetchOrderById } from "../services/orderService";

const OrderOne = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadOrder = async () => {
      try {
        setError("");
        const data = await fetchOrderById(id);
        setOrder(data);
      } catch (err) {
        console.error("Error fetching order details:", err);
        setError("Failed to load order details");
      }
    };

    if (id) {
      loadOrder();
    }
  }, [id]);

  if (!order && !error) {
    return <div>Loading...</div>;
  }

  const formattedDate = order?.date
    ? moment(order.date).format("MMMM Do, YYYY")
    : "N/A";

  const userName =
    order?.user?.fullName || order?.user?.email || order?.user?.mobileNumber;

  const prescriptionUrl = order?.prescription
    ? order.prescription.startsWith("http")
      ? order.prescription
      : `${BaseUrl}${order.prescription}`
    : null;

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Avijo</Breadcrumb.Item>
            <Breadcrumb.Item href="/order-management">
              Order Management
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{order?.orderId || "Order"}</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Order Details</h4>
        </div>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {order && (
        <Table striped bordered hover className="mb-4">
          <tbody>
            <tr>
              <td>Order ID</td>
              <td>{order.orderId}</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>{order.status}</td>
            </tr>
            <tr>
              <td>Date</td>
              <td>{formattedDate}</td>
            </tr>
            <tr>
              <td>User</td>
              <td>{userName || "N/A"}</td>
            </tr>
            <tr>
              <td>Payment Method</td>
              <td>{order.paymentMethod}</td>
            </tr>
            <tr>
              <td>Delivery Address</td>
              <td>{order.address}</td>
            </tr>
            <tr>
              <td>Prescription</td>
              <td>
                {prescriptionUrl ? (
                  <a
                    href={prescriptionUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Prescription
                  </a>
                ) : (
                  "No prescription"
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  );
};

export default OrderOne;

